export const NEED_SOME_HELP_TEXT = "NEED_SOME_HELP_TEXT"
export const WHATSAPP_FORM_DES = "WHATSAPP_FORM_DES"
export const WHATSAPP_BTN_TITLE = "WHATSAPP_BTN_TITLE"
export const CALL_BACK_FORM_HEADING = "CALL_BACK_FORM_HEADING"
export const CALL_BACK_FORM_DES = "CALL_BACK_FORM_DES"
export const WE_ARE_HERE_ASSIST_YOU_TEXT = "WE_ARE_HERE_ASSIST_YOU_TEXT"
export const CALL_BACK_REQUEST_SUBMITTED_TEXT ="CALL_BACK_REQUEST_SUBMITTED_TEXT"

export const WHATSAPP_BTN_ID = "whatsApp-btn"
export const CALL_BACK_BTN_ID = "callBack-btn"
export const WHATSAPP_REDIRECT_URL_TEXT = "whatsAppRedirectionUrl"
